import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DescriptionIcon from '@mui/icons-material/Description';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';

import PageTitle from '@/shared/components/layouts/PageTitle';
import { AppPath } from '@/shared/constants/path';

type TitleProps = {
  isDiscardButtonDisabled: boolean;
  isSaveButtonDisabled: boolean;
  onDiscard: () => void;
  onSaveOrder: () => void;
  onCurrencyChange: (currency: string) => void;
};

const Title: FC<TitleProps> = ({
  isDiscardButtonDisabled,
  isSaveButtonDisabled,
  onDiscard,
  onSaveOrder,
  onCurrencyChange,
}) => {
  const { t } = useTranslation(['orders', 'common']);

  const [currency, setCurrency] = useState('CAD');

  return (
    <PageTitle
      title={t('orders:createOrder')}
      breadcrumbs={[
        {
          label: t('common:orders'),
          icon: (
            <DescriptionIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
          to: AppPath.Orders,
        },
        {
          label: t('orders:createOrder'),
          icon: (
            <DescriptionIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
        },
      ]}
      actions={
        <Stack direction='row' spacing={2}>
          <Select
            value={currency}
            onChange={(e) => {
              setCurrency(e.target.value);
              onCurrencyChange(e.target.value);
            }}
          >
            <MenuItem value='CAD'>CAD</MenuItem>
            <MenuItem value='USD'>USD</MenuItem>
          </Select>

          <Button
            variant='outlined'
            disabled={isDiscardButtonDisabled}
            onClick={onDiscard}
          >
            {t('common:discard')}
          </Button>

          <Button
            variant='contained'
            disabled={isSaveButtonDisabled}
            onClick={onSaveOrder}
          >
            {t('orders:saveOrder')}
          </Button>
        </Stack>
      }
    />
  );
};

export default Title;
